import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymrqc4ecjy: FaireProductEntity = {
  token: "p_ymrqc4ecjy",
  type: "product",
  name: "Birthday Layer Cake Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/43f45de59e911dd85232e212707431922073c8eb82e4e7bef29f5d8c47df2aa3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1fab2d94d4dddd354b84607f9f6fc79dc0c256bec43eb015251f2c762ae194ec.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg"
  ],
  priceDollars: 3,
  description: "As an offering from E. Frances Paper, our Birthday Layer Cake Greeting Card encapsulates our ethos of pure, positive joy and connection. Emblazoned with the playful sentiment 'Life is short - the bigger the cake the better,' this card is perfect for sending birthday wishes with a dash of humor. Crafted in Newport, RI, it's more than just a card - it's a conduit of happiness for the recipient.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:18.621Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
